/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Blockers_HeadingInputs */



/**
* | output |
* | --- |
* | "Before downgrading, you need to:" |
*
* @param {Sub_Downgrade_Blockers_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_blockers_heading = /** @type {((inputs?: Sub_Downgrade_Blockers_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Blockers_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vor dem Downgrade müssen Sie:")
	return /** @type {LocalizedString} */ ("Before downgrading, you need to:")
});